import React from 'react';

const PostTimerHero = ({
  subreddit,
  setSubreddit,
  handleAnalyze,
  loading,
  handleFocus
}) => {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[var(--color-primary-accent)] via-[#1A535C] to-[var(--color-secondary-accent)] text-white p-4 py-6 md:p-12 md:pb-2 mb-10 shadow-2xl shadow-primary/20 flex flex-col justify-center" data-testid="postTimerHero-container">
      <div className="absolute inset-0 bg-black/40 rounded-2xl"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-5xl md:text-7xl font-black tracking-tighter mb-4">Find the Best Time to Post</h1>
        <p className="text-xl md:text-2xl max-w-3xl mx-auto text-white/90 leading-relaxed mt-6 mb-8">
          Analyze any subreddit to discover the optimal times to post for maximum visibility and engagement.
        </p>

        <div id="post-timer-form-container" className="bg-white/10 backdrop-blur-sm border border-white/20 pt-6 pb-1 px-8 rounded-xl max-w-5xl mx-auto">
          <form onSubmit={handleAnalyze} className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-6 items-center" data-testid="postTimerHero-form">
            <div className="relative">
              <label htmlFor="subreddit-url" className="sr-only">Subreddit URL</label>
              <input
                id="subreddit-url"
                name="post-timer-subreddit"
                className="w-full bg-transparent border-none rounded-md pl-4 pr-4 py-4 text-white placeholder:text-white/50 focus:ring-2 focus:ring-[var(--color-primary-accent)] transition"
                placeholder="Enter Subreddit or URL"
                type="text"
                value={subreddit}
                onFocus={handleFocus}
                onChange={(e) => setSubreddit(e.target.value)}
                required
                data-testid="postTimerHero-subredditInput"
              />
            </div>
            <div>
              <button
                type="submit"
                id="analyze-button"
                disabled={loading}
                className="w-full bg-[var(--color-primary-accent)] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[var(--color-secondary-accent)] transition-colors shadow-lg h-full flex items-center justify-center relative"
                data-testid="postTimerHero-analyzeButton"
              >
                {loading && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="spinner"></div>
                  </div>
                )}
                <span className={`flex items-center justify-center gap-2 ${loading ? 'invisible' : ''}`}>
                  <span className="material-symbols-outlined">analytics</span>
                  Analyze
                </span>
              </button>
            </div>
          </form>
        </div>

        <div className="mt-4 text-center relative z-10">
          <p className="text-white/70 text-xs mb-2 leading-relaxed">
            This service analyzes publicly available Reddit content. Usage is subject to
            <a href="https://www.redditinc.com/policies/data-api-terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-white mx-1">Reddit's API Terms</a>
            and our
            <a href="/privacy-policy" className="underline hover:text-white mx-1">Privacy Policy</a>.
            <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default PostTimerHero;
